<template>
  <div>
    <button class="btn btn-green" @click="showModal">+ New driver</button>

    <!-- Modal -->
    <div v-if="show" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">New Driver Profile</h5>
          <button type="button" class="btn-close" @click="closeModal">X</button>
        </div>
        <div class="modal-body">
          <div class="">
            <!-- Tab 切換 -->
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'general' }" @click="activeTab = 'general'">General</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'payment' }" @click="activeTab = 'payment'">Payment details</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'documents' }" @click="activeTab = 'documents'">Documents</a>
              </li>
            </ul>

            <!-- General Tab -->
            <div v-if="activeTab === 'general'" class="tab-content">
              <div class="row d-flex align-items-start">
                <div class="col-xxl-6 col-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12">
                          <h5>Driver Information</h5>
                        </div>
                        <div class="col-12 col-md-8">
                          <label for="driver_id" class="form-label">Driver ID <span class="text-danger">*</span></label>
                          <input type="text" v-model="driver.driver_id" class="form-control" :class="{ 'is-invalid': errors.driver_id }" />
                          <div v-if="errors.driver_id" class="invalid-feedback">{{ errors.driver_id }}</div>
                        </div>
                        <div class="col-12 col-md-4">
                          <label for="birthday" class="form-label">Date of birth <span class="text-danger">*</span></label>
                          <Datepicker1 
                            class="datepicker-here form-control" 
                            v-model="driver.birthday" 
                            :format="'dd/MM/yyyy'" 
                            :enable-time-picker="false" 
                            data-language="en" 
                            placeholder="Select date of birth" 
                            :class="{ 'is-invalid': errors.birthday }"
                          />
                          <div v-if="errors.birthday" class="invalid-feedback">{{ errors.birthday }}</div>
                        </div>
                        <div class="col-12 col-md-6">
                          <label for="first-name" class="form-label">First name <span class="text-danger">*</span></label>
                          <input type="text" v-model="driver.firstName" class="form-control" :class="{ 'is-invalid': errors.firstName }" />
                          <div v-if="errors.firstName" class="invalid-feedback">{{ errors.firstName }}</div>
                        </div>
                        <div class="col-12 col-md-6">
                          <label for="middle-name" class="form-label">Middle name <span class="text-danger">*</span></label>
                          <input id="middle-name" type="text" v-model="driver.middleName" class="form-control" :class="{ 'is-invalid': errors.middleName }" />
                          <div v-if="errors.middleName" class="invalid-feedback">{{ errors.middleName }}</div>
                        </div>
                        <div class="col-12 col-md-6">
                          <label for="last-name" class="form-label">Last name <span class="text-danger">*</span></label>
                          <input type="text" v-model="driver.lastName" class="form-control" :class="{ 'is-invalid': errors.lastName }" />
                          <div v-if="errors.lastName" class="invalid-feedback">{{ errors.lastName }}</div>
                        </div>
                        <div class="col-md-6 col-12">
                          <label for="address" class="form-label">Address <span class="text-danger">*</span></label>
                          <textarea class="form-control" v-model="driver.address" rows="4" :class="{ 'is-invalid': errors.address }"></textarea>
                          <div v-if="errors.address" class="invalid-feedback">{{ errors.address }}</div>
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="row">
                            <div class="col-12">
                              <label for="suburb" class="form-label">Suburb <span class="text-danger">*</span></label>
                              <input type="text" v-model="driver.suburb" class="form-control" :class="{ 'is-invalid': errors.suburb }" />
                              <div v-if="errors.suburb" class="invalid-feedback">{{ errors.suburb }}</div>
                            </div>
                            <div class="col-md-6 col-12">
                              <label for="state" class="form-label">State <span class="text-danger">*</span></label>
                              <select class="form-select digits" v-model="driver.state" :class="{ 'is-invalid': errors.state }">
                                <option value="NSW">NSW</option>
                                <option value="VIC">VIC</option>
                                <option value="QLD">QLD</option>
                                <option value="SA">SA</option>
                                <option value="WA">WA</option>
                                <option value="NT">NT</option>
                                <option value="TAS">TAS</option>
                                <option value="ACT">ACT</option>
                              </select>
                              <div v-if="errors.state" class="invalid-feedback">{{ errors.state }}</div>
                            </div>
                            <div class="col-md-6 col-12">
                              <label for="post-code" class="form-label">Post code <span class="text-danger">*</span></label>
                              <input type="text" v-model="driver.postCode" class="form-control" :class="{ 'is-invalid': errors.postCode }" />
                              <div v-if="errors.postCode" class="invalid-feedback">{{ errors.postCode }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <label for="mobile" class="form-label">Mobile <span class="text-danger">*</span></label>
                          <input type="tel" v-model="driver.mobile" class="form-control" :class="{ 'is-invalid': errors.mobile }" />
                          <div v-if="errors.mobile" class="invalid-feedback">{{ errors.mobile }}</div>
                        </div>
                        <div class="col-md-6 col-12">
                          <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                          <input type="email" v-model="driver.email" class="form-control" :class="{ 'is-invalid': errors.email }" />
                          <div v-if="errors.email" class="invalid-feedback">{{ errors.email }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12">
                          <h5>Password</h5>
                        </div>
                        <div class="col-md-6 col-12">
                          <label for="pin" class="form-label">Pin <span class="text-danger">*</span></label>
                          <input type="password" v-model="driver.pin" class="form-control" :class="{ 'is-invalid': errors.pin }" />
                          <div v-if="errors.pin" class="invalid-feedback">{{ errors.pin }}</div>
                        </div>
                        <div class="col-md-3 col-12 mt-4">
                          <div class="checkbox checkbox-success checked_green">
                            <input id="accessEnabled" type="checkbox" v-model="driver.accessEnabled">
                            <label for="accessEnabled">Access enabled</label>
                          </div>
                        </div>
                        <div class="col-md-3 col-12 mt-4">
                          <div class="checkbox checkbox-success checked_green">
                            <input id="badDriver" type="checkbox" v-model="driver.badDriver">
                            <label for="badDriver">Bad driver</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xxl-3 col-12 justify-content-start">
                  <div class="row">
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-12">
                            <h5>Licensing & Operations</h5>
                          </div>
                          <div class="col-12">
                            <label for="license-number" class="form-label">License number <span class="text-danger">*</span></label>
                            <input type="text" v-model="driver.licenseNumber" class="form-control" :class="{ 'is-invalid': errors.licenseNumber }" />
                            <div v-if="errors.licenseNumber" class="invalid-feedback">{{ errors.licenseNumber }}</div>
                          </div>
                          <div class="col-12">
                            <label for="plate-number" class="form-label">Plate number <span class="text-danger">*</span></label>
                            <input type="text" v-model="driver.plateNumber" class="form-control" :class="{ 'is-invalid': errors.plateNumber }" />
                            <div v-if="errors.plateNumber" class="invalid-feedback">{{ errors.plateNumber }}</div>
                          </div>
                          <div class="col-12">
                            <label for="abn" class="form-label">ABN <span class="text-danger">*</span></label>
                            <input type="text" v-model="driver.abn" class="form-control" :class="{ 'is-invalid': errors.abn }" />
                            <div v-if="errors.abn" class="invalid-feedback">{{ errors.abn }}</div>
                          </div>
                          <div class="col-12">
                            <label for="abn" class="form-label">Confirmed ABN <span class="text-danger">*</span></label>
                            <input type="text" v-model="driver.confirmedAbn" class="form-control" :class="{ 'is-invalid': errors.confirmedAbn }" />
                            <div v-if="errors.confirmedAbn" class="invalid-feedback">{{ errors.confirmedAbn }}</div>
                          </div>
                          <div class="col-12">
                            <label for="commission-subgroup" class="form-label">Commission subgroup <span class="text-danger">*</span></label>
                            <select class="form-select digits" v-model="driver.subgroup" :class="{ 'is-invalid': errors.subgroup }">
                              <option value="" disabled selected>Select...</option>
                              <option v-for="(item, idx) in paginatedData" :key="idx" :value="item.id">{{ item.name }}</option>
                            </select>
                            <div v-if="errors.subgroup" class="invalid-feedback">{{ errors.subgroup }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xxl-3 col-12">
                  <div class="card notes">
                    <div class="card-body">
                      <h5>Notes</h5>
                      <div class="notes-list">
                        <div v-for="note in sortedNotes" :key="note.id" class="note-item">
                          <div class="row note-header">
                            <div class="col">
                              <p>{{ note.date }}</p>
                            </div>
                            <div class="col text-end">
                              <p>{{ note.author }}</p>
                            </div>
                          </div>
                          <div class="note-body">
                            <div>
                              <p>{{ note.text }}</p>
                            </div>
                            <div class="note-body-button text-center">
                              <button @click="togglePin(note.id)" class="note-btn p-0 btn btn-link btn"  :class="{'pinned': note.pinned}">
                                <img v-if="note.pinned != false" src="@/assets/images/admin/cashpayments/mark-active.png" alt="" style="width: 20px; height: 20px;" />
                                <img v-else src="@/assets/images/admin/cashpayments/mark-inactive.png" alt="delete" style="width: 20px; height: 20px;" />
                              </button>
                              <button @click="removeNote(note.id)" class="note-btn btn btn-link btn">
                                <img src="@/assets/images/admin/cashpayments/trush.png" alt="delete" style="width: 20px; height: 20px;" />
                              </button>
                            </div>
                          </div>
                          
                        </div>
                      </div>
                      <div class="add-note-section">
                        <button class="btn btn-sm p-0" @click="showAddNoteInput = true">
                          <img class="note-add_btn" src="@/assets/images/admin/cashpayments/addnote.png" alt="Add Note" style="width: 30px; height: 30px;" />
                        </button>
                        <div v-if="showAddNoteInput" class="add-note-input">
                          <p class="m-1">Add Note</p>
                          <textarea v-model="newNoteText" rows="3" class="form-control"></textarea>
                          <div class="text-end mt-2">
                            <button class="btn p-0 text_gary" @click="cancelAddNote">Cancel</button>
                            <button class="btn ms-3 p-0 text_purple" @click="addNote">Add</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Payment Details Tab -->
            <div v-if="activeTab === 'payment'" class="tab-content">
              <div class="row d-flex align-items-start">
                <div class="col-xxl-4">
                  <div class="card mb-0">
                    <div class="card-body">
                      <h5>Method</h5>
                      <select class="form-select digits" v-model="driver.paymentMethod" @change="handlePaymentMethodChange" :class="{ 'is-invalid': errors.paymentMethod }">
                        <option value="Bank transfer">Bank transfer</option>
                        <option value="Cash">Cash</option>
                      </select>
                      <div v-if="errors.paymentMethod" class="invalid-feedback">{{ errors.paymentMethod }}</div>
                    </div>
                  </div>
                  <div class="card mt-3">
                    <div class="card-body">   
                      <div class="media">
                        <label class="col-form-label m-r-10 f-20">Payment enabled?</label>
                        <div class="media-body text-end icon-state switch-outline">
                          <label class="switch">
                            <input type="checkbox" v-model="driver.paymentEnabled"><span class="switch-state bg-success"></span>
                          </label>
                        </div>
                      </div>
                      <div class="media mt-2">
                        <label class="col-form-label m-r-10 f-20">Withdraw funds enabled?</label>
                        <div class="media-body text-end icon-state switch-outline">
                          <label class="switch">
                            <input type="checkbox" v-model="driver.withdraw_enabled"><span class="switch-state bg-success"></span>
                          </label>
                        </div>
                      </div>
                      <div class="media mt-2">
                        <label class="col-form-label m-r-10 f-20">Driver pre-card enabled?</label>
                        <div class="media-body text-end icon-state switch-outline">
                          <label class="switch">
                            <input type="checkbox" v-model="driver.driverPreCardEnabled"><span class="switch-state bg-success"></span>
                          </label>
                        </div>
                      </div>
                      <div class="media mt-2" v-if="cardAccount">
                        <label class="col-form-label m-r-10 f-20">Card auto-card enabled?</label>
                        <div class="media-body text-end icon-state switch-outline">
                          <label class="switch">
                            <input type="checkbox" v-model="cardAccount.auto_pay"><span class="switch-state bg-success"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-0">
                    <div class="card-body">
                      <h5>Referral information (if applicable)</h5>
                      <div class="row">
                        <div class="col-12">
                          <label for="referring-driver-id" class="form-label">Referring driver ID</label>
                          <input type="text" v-model="driver.referringDriverId" class="form-control" />
                        </div>
                        <div class="col-12">
                          <label for="referring-driver-name" class="form-label">Referring driver name</label>
                          <input type="text" v-model="driver.referringDriverName" class="form-control" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="col-xxl-8">
                  <div class="card mb-0">
                    <div class="card-body">
                      <h5 v-if="driver.paymentMethod === 'Bank transfer'">Bank details</h5>
                      <h5 v-else>Bank / PayID details</h5>

                      <div v-if="driver.paymentMethod === 'Cash'">
                        <button class="btn btn-sm d-flex justify-content-between align-items-center" @click="addAccount">
                          <img class="note-add_btn" src="@/assets/images/admin/cashpayments/addnote.png" alt="Add Note" style="width: 30px; height: 30px;" />
                          <div class="ms-3">Add details</div>
                        </button>
                      </div>
                      <hr>
                      <div
                        v-for="(account, idx) in driver.accounts"
                        :key="account.tempId"
                      >
                        <div class="row d-flex align-items-center">
                            <div v-if="driver.paymentMethod === 'Cash'" class="col-1">
                              <div>
                                  <button class="btn" @click="removeAccount(idx)">
                                    <img src="@/assets/images/admin/cashpayments/trush.png" alt="delete" style="width: 20px; height: 20px;" />
                                  </button>
                              </div>
                            </div>
                            <div class="row" :class="driver.paymentMethod == 'Cash' ? 'col-11': 'col-12'">
                              <div class="col-md-6 col-12 mt-2">
                                <label class="form-label">
                                  Nick name <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  v-model="account.nick_name"
                                  class="form-control"
                                  :class="{ 'is-invalid': account.errors?.nick_name }"
                                />
                                <div v-if="account.errors?.nick_name" class="invalid-feedback">
                                  {{ account.errors.nick_name }}
                                </div>
                              </div>

                              <div class="col-md-6 col-12 mt-2" v-if="driver.paymentMethod === 'Cash'">
                                <label class="form-label">Account type</label>
                                <select
                                  class="form-select digits"
                                  v-model="account.type"
                                  :class="{ 'is-invalid': account.errors?.type }"
                                >
                                  <option value="1">Bank account</option>
                                  <option value="2">PayID phone</option>
                                  <option value="3">PayID email</option>
                                  <option value="4">Card</option>
                                </select>
                                <div v-if="account.errors?.type" class="invalid-feedback">
                                  {{ account.errors.type }}
                                </div>
                              </div>

                              <div class="col-12 mt-2" :class="driver.paymentMethod === 'Cash' && account.type === '1' ? 'col-md-3' : 'col-md-6'">
                                <label class="form-label">
                                  Account name <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  v-model="account.account_name"
                                  class="form-control"
                                  :class="{ 'is-invalid': account.errors?.account_name }"
                                  :disabled="driver.paymentMethod === 'Cash' && (account.type === '2' || account.type === '3')"
                                />
                                <div v-if="account.errors?.account_name" class="invalid-feedback">
                                  {{ account.errors.account_name }}
                                </div>
                              </div>

                              <template v-if="account.type == '1'">
                                <div class="col mt-2">
                                  <label class="form-label">
                                    Bank <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    v-model="account.bank"
                                    class="form-control"
                                    :class="{ 'is-invalid': account.errors?.bank }"
                                  />
                                  <div v-if="account.errors?.bank" class="invalid-feedback">
                                    {{ account.errors.bank }}
                                  </div>
                                </div>
                                <div class="col mt-2">
                                  <label class="form-label">
                                    BSB <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    v-model="account.bsb"
                                    class="form-control"
                                    :class="{ 'is-invalid': account.errors?.bsb }"
                                  />
                                  <div v-if="account.errors?.bsb" class="invalid-feedback">
                                    {{ account.errors.bsb }}
                                  </div>
                                </div>
                                <div class="col mt-2">
                                  <label class="form-label">
                                    Account number <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    v-model="account.account_number"
                                    class="form-control"
                                    :class="{ 'is-invalid': account.errors?.account_number }"
                                  />
                                  <div v-if="account.errors?.account_number" class="invalid-feedback">
                                    {{ account.errors.account_number }}
                                  </div>
                                </div>
                              </template>

                              <template v-else-if="account.type == '2'">
                                <div class="col-md-6 col-12 mt-2">
                                  <label class="form-label">
                                    PayID Phone <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    v-model="account.phone"
                                    @keyup.enter="handlePayIdEnter(account, 'PHONE')"
                                    @input="clearAccountName(account)"
                                    class="form-control"
                                    :class="{ 'is-invalid': account.errors?.phone }"
                                  />
                                  <div v-if="account.errors?.phone" class="invalid-feedback">
                                    {{ account.errors.phone }}
                                  </div>
                                </div>
                              </template>

                              <template v-else-if="account.type == '3'">
                                <div class="col-md-6 col-12 mt-2">
                                  <label class="form-label">
                                    PayID Email <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    v-model="account.email"
                                    @keyup.enter="handlePayIdEnter(account, 'EMAIL')"
                                    @input="clearAccountName(account)"
                                    class="form-control"
                                    :class="{ 'is-invalid': account.errors?.email }"
                                  />
                                  <div v-if="account.errors?.email" class="invalid-feedback">
                                    {{ account.errors.email }}
                                  </div>
                                </div>
                              </template>

                              <template v-else-if="account.type == '4'">
                                <div class="col-md-6 col-12 mt-2">
                                  <label class="form-label">
                                    Card ID(EAID) <span class="text-danger">*</span>
                                  </label>
                                  <input type="text" v-model="account.card_id" class="form-control" :class="{ 'is-invalid': account.errors?.card_id }" />
                                  <div v-if="account.errors?.card_id" class="invalid-feedback">{{ account.errors.card_id }}</div>
                                </div>
                              </template>
                          </div>          
                        </div>      
                        <hr>
                      </div>                      
                    </div>
                  </div>
                </div>             
              </div>
            </div>

            <!-- Documents Tab -->
            <div v-if="activeTab === 'documents'" class="tab-content">
              <div class="row d-flex align-items-start">
                <div class="col-xxl-8">
                  <div class="card card-mh">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12">
                          <h5>Driving License</h5>
                        </div>
                        <div class="col-md-6 col-12 mt-3">
                          <!-- Upload License Front -->
                          <div class="file-upload">
                            <div class="license-preview" v-if="driver.licenseFrontFile.length">
                              <img :src="getObjectURL(driver.licenseFrontFile[0])" alt="License Front Preview" class="img-fluid" />
                            </div>
                            <div class="license-placeholder" v-else>
                              No license on file
                            </div>
                            <input type="file" @change="uploadLicenseFront" accept="image/*" class="d-none" ref="licenseFrontInput" />
                            <button class="mt-3 btn-w-transparent btn btn-outline-primary mt-2" @click="triggerFileInput('licenseFrontInput')">Upload license front</button>
                            <div v-if="errors.licenseFrontFile" class="invalid-feedback">{{ errors.licenseFrontFile }}</div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12 mt-3">
                          <!-- Upload License Back -->
                          <div class="file-upload">
                            <div class="license-preview" v-if="driver.licenseBackFile.length">
                              <img :src="getObjectURL(driver.licenseBackFile[0])"  alt="License Back Preview" class="img-fluid" />
                            </div>
                            <div class="license-placeholder" v-else>
                              No license on file
                            </div>
                            <input type="file" @change="uploadLicenseBack" accept="image/*" class="d-none" ref="licenseBackInput" />
                            <button class="mt-3 btn-w-transparent btn btn-outline-primary mt-2" @click="triggerFileInput('licenseBackInput')">Upload license back</button>
                            <div v-if="errors.licenseBackFile" class="invalid-feedback">{{ errors.licenseBackFile }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-12">
                  <div class="card card-other card-mh">
                    <div class="card-body" style="padding: 1rem">
                      <h5>Other Documents</h5>
                      <div class="document-list p-3">
                        <div v-for="(doc, index) in driver.otherDocuments" :key="index" class="document-item pb-3 mb-3">
                          <span class="document-name">{{ doc.name }}</span>
                          <div>
                            <button class="document-button py-0 btn btn-link btn-view" @click="openPreviewModal(index)">
                              <img class="note-add_btn" src="@/assets/images/admin/cashpayments/view.png" alt="view" style="width: 25px; height: 25px;" />
                            </button>
                            <button class="document-button py-0 btn btn-link" @click="removeDocument(index)">
                              <img class="note-add_btn" src="@/assets/images/admin/cashpayments/trush.png" alt="delete" style="width: 25pxx; height: 25px;" />
                            </button>
                          </div>
                        </div>
                        <div class="add-document justify-content-start">
                          <button class="document-add_btn p-0 btn btn-primary btn-sm" @click="triggerFileInput('fileInput')">
                            <img class="note-add_btn" src="@/assets/images/admin/cashpayments/addnote.png" alt="Add Note" style="width: 30px; height: 30px;" />
                          </button>
                          <input type="file" ref="fileInput" @change="handleFileUpload" class="d-none" />
                          <div v-if="errors.otherDocuments" class="invalid-feedback">{{ errors.otherDocuments }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="modal-footer">
          <div class="row justify-content-start">
            <div class="col">
              <button class="btn btn-green" @click="submitDriver">Save</button>
            </div>
            <div class="col">
              <button class="btn btn-cancel btn-w" @click="closeModal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 預覽圖片 -->
    <div v-if="showPreview" class="preview-modal-overlay" @click.self="closePreviewModal">
      <div class="preview-modal-content">
        <button type="button" class="btn-close justify-content-end" @click="closePreviewModal">X</button>
        <div class="preview-content">
          <img :src="getObjectURL(previewDocument.content)" alt="Document Preview" class="img-fluid" />
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import { useDriverStore } from '@/store/admin/driver';
import { useSubgroupStore } from '@/store/admin/subgroup';
import Swal from 'sweetalert2';
import Datepicker1 from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'; 

const show = ref(false);
const activeTab = ref('general');
const showAddNoteInput = ref(false);
const newNoteText = ref('');
const showPreview = ref(false);
const previewDocument = ref({});
const driverStore = useDriverStore();
const subgroupStore = useSubgroupStore();
const userData = localStorage.getItem('User');
const userObject = JSON.parse(userData);


const errors = reactive({
  driver_id: '',
  birthday: '',
  firstName: '',
  middleName: '',
  lastName: '',
  address: '',
  suburb: '',
  state: '',
  postCode: '',
  mobile: '',
  email: '',
  pin: '',
  licenseNumber: '',
  plateNumber: '',
  abn: '',
  confirmedAbn: '',
  subgroup: '',
  paymentMethod: '',
  licenseFrontFile: '',
  licenseBackFile: '',
  otherDocuments: '',
});

const format = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  const hh = String(date.getHours()).padStart(2, '0'); // 小時補齊2位數
  const min = String(date.getMinutes()).padStart(2, '0'); // 分鐘補齊2位數

   return `${day}/${month}/${year} ${hh}:${min}`; // 返回完整日期與時間
};

const paginatedData = computed(() => {
  return subgroupStore.paginatedData;
});

// Driver data
const driver = reactive({
  driver_id: '',
  birthday: null,
  firstName: '',
  middleName: '',
  lastName: '',
  address: '',
  suburb: '',
  state: '',
  postCode: '',
  mobile: '',
  email: '',
  pin: '',
  accessEnabled: true,
  badDriver: false,
  licenseNumber: '',
  plateNumber: '',
  abn: '', 
  confirmedAbn: '',
  subgroup: '',
  licenseFrontFile: [],
  licenseBackFile: [],
  otherDocuments: [],
  notes: [],
  paymentMethod: 'Bank transfer',
  paymentEnabled: true,
  withdraw_enabled: true,
  driverPreCardEnabled: true,
  referringDriverId: '',
  referringDriverName: '',
  accounts: [],
});

// File input references
const licenseFrontInput = ref(null);
const licenseBackInput = ref(null);
const fileInput = ref(null);

const showModal = () => {
  show.value = true;
  activeTab.value = 'general';
};

const closeModal = () => {
  show.value = false;
  resetForm();
};

const resetForm = () => {
  // 重置 driver 物件中的所有字段
  Object.keys(driver).forEach((key) => {
    if (Array.isArray(driver[key])) {
      driver[key] = [];
    } else if (typeof driver[key] === 'boolean') {
      driver[key] = false;
    } else if (key === 'birthday') {
      driver[key] = null;
    } else {
      driver[key] = '';
    }
  });

  // 重置表單的其他狀態
  activeTab.value = 'general';
  showAddNoteInput.value = false;
  newNoteText.value = '';
  previewDocument.value = {};
  showPreview.value = false;
  driver.accessEnabled = true,
  driver.paymentEnabled = true,

  // 清空錯誤訊息
  Object.keys(errors).forEach((key) => {
    errors[key] = '';
  });
};

const sortedNotes = computed(() => {
  return [...driver.notes].sort((a, b) => b.pinned - a.pinned);
});

const addNote = () => {
  const adminData = JSON.parse(localStorage.getItem('Admin') || '{}'); // 從 localStorage 取得 Admin 資訊
  const currentAuthor = adminData.username || 'Unknown'; // 使用 username，如果找不到則設為 'Unknown'

  if (newNoteText.value.trim()) {
    driver.notes.push({
      id: generateId(),
      text: newNoteText.value,
      date: format(new Date()),
      author: currentAuthor, 
      pinned: false,
    });
    newNoteText.value = '';
    showAddNoteInput.value = false;
  }
};

const cancelAddNote = () => {
  newNoteText.value = '';
  showAddNoteInput.value = false;
};
const cardAccount = computed(() => {
  if (!driver.accounts || !Array.isArray(driver.accounts)) return null;
  return driver.accounts.find(acc => acc.type === '4') || null;
});
const removeNote = (id) => {
  Swal.fire({
    title: 'Are you sure?',
    text: "Do you really want to delete this note?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
  }).then((result) => {
    if (result.isConfirmed) {
      const noteIndex = driver.notes.findIndex((note) => note.id === id);
      if (noteIndex !== -1) {
        driver.notes.splice(noteIndex, 1);
      } 
    }
  });
};

const togglePin = (id) => {
  const note = driver.notes.find((note) => note.id === id);
  if (note) {
    note.pinned = !note.pinned;
  }
};

const handlePaymentMethodChange = () => {
  if (driver.paymentMethod === 'Bank transfer') {
    // 若原先 accounts 有多筆 => 保留第一筆即可
    if (driver.accounts.length > 0) {
      driver.accounts = [driver.accounts[0]];
      driver.accounts[0].type = '1'; // 強制 Bank
    } else {
      // 若完全沒有帳號 => 新增一筆 Bank
      addAccount(true);
    }
  }
  if(driver.paymentMethod === 'Cash'){
    if(driver.accounts.length <1){
      addAccount(true);
    }
  }
};


const clearAccountName = (account) => {
  if (account.account_name) {
    account.account_name = '';
  }
};

const handlePayIdEnter = async (account, type) => {
  let pay_id = type === 'PHONE' ? account.phone : account.email;
  if (!pay_id) return;
  try {
    const accountName = await driverStore.GetPayIdAccountName(pay_id, type);
    if (accountName) {
      account.account_name = accountName;
      account.errors.account_name = '';
    }else{
      account.account_name = '';
      account.errors.account_name = 'Account name not found. Please try again.'
    }
  } catch (error) {
    console.error(error);
  }
};

const addAccount = (isBank = false) => {
  // 如果 paymentMethod=Bank => 只允許一筆 => 不可再新增
  if (driver.paymentMethod === 'Bank transfer') return;

  driver.accounts.push({
    tempId: generateId(),
    id: null,
    type: isBank ? '1' : '1', // 預設給 '1'(Bank) 或自行切換 => 你可改成 '2' 預設PayID
    nick_name: '',
    account_name: '',
    bank: '',
    bsb: '',
    account_number: '',
    phone: '',
    email: '',
    enabled: false,
    auto_pay: false,
    errors: {},
  });
};

/** 移除帳號 (只在 Cash 時可用) */
const removeAccount = (index) => {
  Swal.fire({
    title: 'Are you sure?',
    text: "Do you really want to remove this account?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, remove it!',
  }).then((result) => {
    if (result.isConfirmed) {
      const acc = driver.accounts[index];
      // 如果後端已經有 id => 可能要另外帶刪除ID (可用 deletedDocumentIds 或另外寫 deletedAccountIds)
      if (acc.id) {
        // 這裡僅示範
        deletedDocumentIds.value.push(acc.id);
      }
      driver.accounts.splice(index, 1);
    }
  });
};

const validateFields = () => {
  let valid = true;

  // 驗證必填欄位
  if (!driver.driver_id) {
    errors.driver_id = 'Driver ID is required.';
    valid = false;
  } else {
    errors.driver_id = '';
  }

  if (!driver.birthday) {
    errors.birthday = 'Date of birth is required.';
    valid = false;
  } else {
    errors.birthday = '';
  }

  if (!driver.firstName) {
    errors.firstName = 'First name is required.';
    valid = false;
  } else {
    errors.firstName = '';
  }

  if (!driver.lastName) {
    errors.lastName = 'Last name is required.';
    valid = false;
  } else {
    errors.lastName = '';
  }

  if (!driver.address) {
    errors.address = 'Address is required.';
    valid = false;
  } else {
    errors.address = '';
  }

  if (!driver.suburb) {
    errors.suburb = 'Suburb is required.';
    valid = false;
  } else {
    errors.suburb = '';
  }

  if (!driver.state) {
    errors.state = 'State is required.';
    valid = false;
  } else {
    errors.state = '';
  }

  if (!driver.postCode) {
    errors.postCode = 'Post code is required.';
    valid = false;
  } else {
    errors.postCode = '';
  }

  if (!driver.mobile) {
    errors.mobile = 'Mobile number is required.';
    valid = false;
  } else if (!/^\d{10}$/.test(driver.mobile)) {
    errors.mobile = 'Mobile number must be 10 digits.';
    valid = false;
  } else {
    errors.mobile = '';
  }

  if (!driver.email) {
    errors.email = 'Email is required.';
    valid = false;
  } else if (!/\S+@\S+\.\S+/.test(driver.email)) {
    errors.email = 'Invalid email address.';
    valid = false;
  } else {
    errors.email = '';
  }

  // 新增密碼長度驗證
  if (!driver.pin) {
    errors.pin = 'Pin is required.';
    valid = false;
  } else if (!/^\d{6}$/.test(driver.pin)) {
    errors.pin = 'Pin must be exactly 6 digits long and contain only numbers.';
    valid = false;
  } else {
    errors.pin = '';
  }

  if (!driver.licenseNumber) {
    errors.licenseNumber = 'License number is required.';
    valid = false;
  } else {
    errors.licenseNumber = '';
  }

  if (!driver.plateNumber) {
    errors.plateNumber = 'Plate number is required.';
    valid = false;
  } else {
    errors.plateNumber = '';
  }

  if (!driver.abn) {
    errors.abn = 'ABN is required.';
    valid = false;
  } else {
    errors.abn = '';
  }

  if (!driver.subgroup) {
    errors.subgroup = 'Commission subgroup is required.';
    valid = false;
  } else {
    errors.subgroup = '';
  }

  driver.accounts.forEach((acc) => {
    acc.errors = {}; // 先清空該筆的錯誤
    if (!acc.nick_name) {
      acc.errors.nick_name = 'Nick name is required.';
      valid = false;
    }
    if (!acc.account_name) {
      acc.errors.account_name = 'Account name is required.';
      valid = false;
    }
    if (acc.type === '1') {
      // Bank account => bank, bsb, account_number 必填
      if (!acc.bank) {
        acc.errors.bank = 'Bank name is required.';
        valid = false;
      }
      if (!acc.bsb) {
        acc.errors.bsb = 'BSB is required.';
        valid = false;
      }
      if (!acc.account_number) {
        acc.errors.account_number = 'Account number is required.';
        valid = false;
      }
    } else if (acc.type === '2') {
      // PayID => phone 必填
      if (!acc.phone) {
        acc.errors.phone = 'Phone is required for PayID.';
        valid = false;
      }
    }

    else if (acc.type === '3') {
      // PayID => phone 必填
      if (!acc.email) {
        acc.errors.email = 'Email is required for PayID.';
        valid = false;
      }
    }
  });


  if (!valid) {
    Swal.fire({
      icon: 'error',
      title: 'Validation Error',
      text: 'Please check the required fields and correct them.',
    });
  }

  return valid;
};

const uploadLicenseFront = (event) => {
  const files = event.target.files;
  if (files.length > 0) {
    const file = files[0];
    const fileType = file.type;
    if (!['image/jpeg', 'image/png'].includes(fileType)) {
      // 檢查檔案類型
      Swal.fire({
        icon: 'error',
        title: 'Invalid file type',
        text: 'Only .jpg and .png files are allowed.',
      });
      driver.licenseFrontFile = []; // 清除文件
      return; // 停止處理
    }
    if (file.size > 25 * 1024 * 1024) {
      // 檢查檔案大小是否超過 25MB
      Swal.fire({
        icon: 'error',
        title: 'File too large',
        text: 'License front file must be smaller than 25MB.',
      });
      driver.licenseFrontFile = []; // 清除文件
    } else {
      driver.licenseFrontFile = [file];
      errors.licenseFrontFile = ''; // 重置錯誤訊息
    }
  }
};

const uploadLicenseBack = (event) => {
  const files = event.target.files;
  if (files.length > 0) {
    const file = files[0];
    const fileType = file.type;
    if (!['image/jpeg', 'image/png'].includes(fileType)) {
      // 檢查檔案類型
      Swal.fire({
        icon: 'error',
        title: 'Invalid file type',
        text: 'Only .jpg and .png files are allowed.',
      });
      driver.licenseBackFile = []; // 清除文件
      return; // 停止處理
    }
    if (file.size > 25 * 1024 * 1024) {
      // 檢查檔案大小是否超過 25MB
      Swal.fire({
        icon: 'error',
        title: 'File too large',
        text: 'License back file must be smaller than 25MB.',
      });
      driver.licenseBackFile = []; // 清除文件
    } else {
      driver.licenseBackFile = [file];
      errors.licenseBackFile = ''; // 重置錯誤訊息
    }
  }
};

const handleFileUpload = (event) => {
  const files = event.target.files;
  if (files.length > 0) {
    const file = files[0];
    const fileType = file.type;
    if (!['image/jpeg', 'image/png'].includes(fileType)) {
      // 檢查檔案類型
      Swal.fire({
        icon: 'error',
        title: 'Invalid file type',
        text: 'Only .jpg and .png files are allowed.',
      });
      return; // 停止處理
    }
    if (file.size > 25 * 1024 * 1024) {
      // 檢查檔案大小是否超過 25MB
      Swal.fire({
        icon: 'error',
        title: 'File too large',
        text: 'Other document file must be smaller than 25MB.',
      });
      return; // 停止處理
    }
    driver.otherDocuments.push({
      id: generateId(),
      name: file.name,
      content: file,
      showPreview: false,
    });
    errors.otherDocuments = ''; // 重置錯誤訊息
  }
};

const triggerFileInput = (refName) => {
  if (refName === 'licenseFrontInput') {
    licenseFrontInput.value?.click();
  } else if (refName === 'licenseBackInput') {
    licenseBackInput.value?.click();
  } else if (refName === 'fileInput') {
    fileInput.value?.click();
  }
};

const openPreviewModal = (index) => {
  previewDocument.value = driver.otherDocuments[index];
  showPreview.value = true;
};

const closePreviewModal = () => {
  showPreview.value = false;
  previewDocument.value = {};
};

const getObjectURL = (file) => {
  return file ? URL.createObjectURL(file) : '';
};

const removeDocument = (index) => {
  Swal.fire({
    title: 'Are you sure?',
    text: "Do you really want to delete this document?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
  }).then((result) => {
    if (result.isConfirmed) {
      if (driver.otherDocuments[index].content) {
        URL.revokeObjectURL(driver.otherDocuments[index].content);
      }
      driver.otherDocuments.splice(index, 1);
      errors.otherDocuments = '';
    }
  });
};

const generateId = () => '_' + Math.random().toString(36).substr(2, 9);

const submitDriver = async () => {
  if (!validateFields()) {
    return; // 如果驗證失敗則停止提交
  }

  // 使用 FormData 來封裝數據
  const formData = new FormData();

  formData.append('driver_id', driver.driver_id);
  // 格式化日期為 YYYY-MM-DD 格式
  if (driver.birthday) {
    const date = new Date(driver.birthday);
    const formattedDate = date.toISOString().split('T')[0];
    formData.append('birthday', formattedDate);
  }
  formData.append('first_name', driver.firstName);
  formData.append('middle_name', driver.middleName);
  formData.append('last_name', driver.lastName);
  formData.append('address', driver.address);
  formData.append('suburb', driver.suburb);
  formData.append('state', driver.state);
  formData.append('post_code', driver.postCode);
  formData.append('mobile', driver.mobile);
  formData.append('email', driver.email);
  formData.append('password', driver.pin);
  formData.append('enabled', driver.accessEnabled ? '1' : '0');
  formData.append('bad_driver', driver.badDriver ? '1' : '0');
  formData.append('license_number', driver.licenseNumber);
  formData.append('plate_number', driver.plateNumber);
  formData.append('abn', driver.abn);
  formData.append('confirmed_abn', driver.confirmedAbn);
  formData.append('subgroup_id', driver.subgroup);
  formData.append('method', driver.paymentMethod);
  formData.append('payment_enabled', driver.paymentEnabled ? '1' : '0');
  formData.append('withdraw_enabled', driver.withdraw_enabled? '1': '0');
  formData.append('driver_pre_card_enabled', driver.driverPreCardEnabled? '1': '0');
  formData.append('referring_driver_id', driver.referringDriverId);
  formData.append('referring_driver_name', driver.referringDriverName);


  driver.accounts.forEach((acc, i) => {
    if (acc.id) {
      formData.append(`accounts[${i}][id]`, acc.id);
    }
    formData.append(`accounts[${i}][account_type]`, acc.type);
    formData.append(`accounts[${i}][nick_name]`, acc.nick_name);
    formData.append(`accounts[${i}][account_name]`, acc.account_name);
    formData.append(`accounts[${i}][bank]`, acc.bank);
    formData.append(`accounts[${i}][bsb]`, acc.bsb);
    formData.append(`accounts[${i}][account_number]`, acc.account_number);
    formData.append(`accounts[${i}][phone]`, acc.phone);
    formData.append(`accounts[${i}][email]`, acc.email);
    formData.append(`accounts[${i}][auto_pay]`, acc.auto_pay ? '1' : '0');
  })

  // 處理 Notes
  driver.notes.forEach((note, index) => {
    formData.append(`notes[${index}][note]`, note.text);
    formData.append(`notes[${index}][eye_catching]`, note.pinned ? '1' : '0');
  });

  // 處理文件上傳
  driver.licenseFrontFile.forEach((file, index) => {
    formData.append(`document_name[${index}]`, 'license_front');
    formData.append(`documents[${index}]`, file);
  });

  driver.licenseBackFile.forEach((file, index) => {
    const indexOffset = driver.licenseFrontFile.length + index;
    formData.append(`document_name[${indexOffset}]`, 'license_back');
    formData.append(`documents[${indexOffset}]`, file);
  });

  driver.otherDocuments.forEach((doc, index) => {
    const indexOffset = driver.licenseFrontFile.length + driver.licenseBackFile.length + index;
    formData.append(`document_name[${indexOffset}]`, 'other_documents');
    formData.append(`documents[${indexOffset}]`, doc.content);
  });

  // 新增打印 FormData 內容的代碼
  for (let [key, value] of formData.entries()) {
    console.log(key, value);
  }

  const response = await driverStore.addDriver(formData);
  closeModal();
};

onMounted(()=>{
  if(driver.accounts.length <1){
      addAccount(true);
    }
});

</script>



<style scoped>
.btn-green {
  background: rgba(0, 201, 98, 1);
  color: black;
  border: none;
  border-radius: 30px;
  width: 150px;
  padding: 10px, 32px, 10px, 32px;
}

.btn-green:hover {
  background: rgba(0, 201, 98, 1);
  border-radius: 30px;
  padding: 10px, 32px, 10px, 32px;
}

.btn-cancel{
  background-color: #e6e9ec;
  border: 2px solid #8476f4;
  width: 150px;
}

.btn-cancel:hover{
  background-color: #e6e9ec;
  border: 2px solid #8476f4;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #e6e9ec;
  /* background-color: #fff; */
  border-radius: 10px;
  width: 90%;
  height: 90%;
  padding: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.background-white {
  background-color: white;
  padding: 10px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-body {
  flex: 1;
}

.tab-content {
  min-height: 600px;
  padding: 20px;
  background-color: #fff;
  border-radius: 0px 10px 10px 10px
}

.modal-footer {
  display: flex;
  justify-content: start;
  padding-top: 20px;
}

.btn-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}
.nav-tabs{
  border: none;
}

.nav-tabs .nav-link {
  border: none;
  margin-bottom: 0;
}

.nav-link.active {  
  color: white;
  background-color: #00c962;
  border: none;
}

.file-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.license-preview {
  width: 100%;
  height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  border-radius: 5%;
  background-color: white;
  padding: 20px;
}

.license-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}


.license-placeholder {
  width: 100%;
  height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 5%;
  padding: 20px;
  color: #999;
  font-size: 16px;
  background-color: white;
}

.card {
  margin-bottom: 12px;
  background-color: #e6e9ec;
}

.card-mh{
  min-height: 600px
}

.card-body_padding{
  padding: 6px 1rem;
}

.card-other {
  height: auto;
}

.form-label{
  margin-top: 10px;
}

.notes {
  height: 620px;
}

.notes-list {
  max-height: 500px; /* 設定筆記列表的最大高度 */
  overflow-y: auto; /* 允許垂直滾動 */
  color: #5E707D;
  padding-right: 10px; /* 增加內邊距以便滾動條不會遮住內容 */
}

/* Optional: 自定義滾動條樣式，這些樣式是可選的，可以根據需求調整 */
.notes-list::-webkit-scrollbar {
  width: 8px;
}

.notes-list::-webkit-scrollbar-thumb {
  background-color: #cccccc; /* 滾動條的顏色 */
  border-radius: 4px;
}

.notes-list::-webkit-scrollbar-thumb:hover {
  background-color: #b3b3b3; /* 滾動條懸停時的顏色 */
}

.notes-list::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* 滾動條背景 */
}

.note-item {
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: white;
  word-wrap: break-word; /* 確保文字在超出範圍時換行 */
  white-space: normal; /* 將white-space設置為normal來強制文字自動換行 */
  overflow-wrap: anywhere; /* 新增這行來強制文字在任何地方換行 */
  max-width: 100%; /* 限制寬度避免超出 */
}

.note-body {
  display: grid;
  grid-template-columns: 1fr 28px;
  word-wrap: break-word;
  white-space: normal; /* 更新這裡的white-space屬性 */
  overflow-wrap: anywhere; /* 同樣添加這行 */
  margin-bottom: 0;
}


.note-add_btn, .document-add_btn{
  width: 28px;
  height: 28px;
  text-align: center;
}

.note-btn{
  margin: 8px auto;
  padding: 0;
  display: block;
}

.add-note-section {
  margin-top: 15px;
}

.add-note-input {
  margin-top: 10px;
  padding: 16px 20px 10px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 0px 12px 0px rgba(5, 28, 44, .1);

}

.add-note-input textarea{
  border: 1px solid #00C962
}

.pinned {
  color: #ff0000;
}

.document-list {
  margin-top: 10px;
  background-color: #fff;
  border-radius: 6px;
  overflow-y: auto;
}

.document-item {
  /* padding-top: 6px; */
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.document-button{
  font-size: 16px;
}

.btn-view{
  border-right: 1px solid gray;
  border-radius: 0px;
}

.document-name {
  font-size: 14px;
  color: #333;
}

.add-document {
  display: flex;
  justify-content: center;
}

/* 預覽模態視窗樣式 */
.preview-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.preview-modal-content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  width: auto;
  height: auto;
  max-width: 800px;
  position: relative;
}

/* 新增的樣式，將關閉按鈕置於右上角 */
.preview-modal-content .btn-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.preview-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

@media (max-width:1400px) {
  .modal-body {
    overflow-y: auto;
  }
}
</style>

